import Card from 'antd/lib/card';
import React from 'react';
import { displayNameForIntegrationType, iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { IntegrationType } from '../../types';
import Text from 'antd/lib/typography/Text';
import { antGrey, runwayColors } from '../styles/globalStyles';
import TrackedButton from '../../helpers/TrackedButton';
import * as Amplitude from '../../utils/analytics';
import { AppComponentProps } from '../../typescriptHelpers';
import {
    getPreferencesForNotifyingOfComingSoonIntegrations,
    setPreferencesForNotifyingOfComingSoonIntegrations,
} from '../../helpers/localStorageHelper';
import Space from 'antd/lib/space';
import { CheckOutlined } from '@ant-design/icons';
import Paragraph from 'antd/lib/typography/Paragraph';

interface ComingSoonIntegrationComponentProps extends AppComponentProps {
    integrationType: IntegrationType;
}

const ComingSoonIntegrationComponent: React.FC<ComingSoonIntegrationComponentProps> = (props) => {
    const { integrationType, orgId } = props;

    const initialIntegrationsSavedToGetNotified = getPreferencesForNotifyingOfComingSoonIntegrations(orgId);

    const [integrationsSavedToGetNotified, setIntegrationsSavedToGetNotified] = React.useState(
        initialIntegrationsSavedToGetNotified,
    );

    const saveGetNotifiedClicked = () => {
        const initialIntegrationsSaved = getPreferencesForNotifyingOfComingSoonIntegrations(orgId);
        const updatedIntegrationsSavedToGetNotified = [...initialIntegrationsSaved, integrationType];

        setPreferencesForNotifyingOfComingSoonIntegrations(orgId, updatedIntegrationsSavedToGetNotified);

        setIntegrationsSavedToGetNotified(updatedIntegrationsSavedToGetNotified);
    };

    const displayName = displayNameForIntegrationType(integrationType);
    const [icon, alt] = iconAndAltForIntegrationType(integrationType);

    const alreadySavedToGetNotifiedList = integrationsSavedToGetNotified.includes(integrationType);

    return (
        <Card style={{ backgroundColor: antGrey.grey2 }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: alreadySavedToGetNotifiedList ? 32 : 33,
                        justifyContent: 'center',
                        gap: '8px',
                    }}
                >
                    {icon && (
                        <img src={icon} alt={alt} style={{ marginRight: 8, opacity: 0.5 }} width={30} height={30} />
                    )}
                    <Text type="secondary" ellipsis>
                        {displayName}
                    </Text>
                </div>
                {alreadySavedToGetNotifiedList ?
                    <Space>
                        <CheckOutlined style={{ color: runwayColors.statusGreen }} />
                        <div>
                            <Paragraph
                                type="secondary"
                                style={{ fontSize: 12, marginBottom: 0 }}
                                ellipsis={{ rows: 2 }}
                            >
                                You&apos;ll be notified when this integration is available
                            </Paragraph>
                        </div>
                    </Space>
                :   <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <Text style={{ flexGrow: 1, margin: 8, textAlign: 'center' }}>Coming soon!</Text>
                        <TrackedButton
                            orgId={orgId}
                            style={{ flexGrow: 1 }}
                            eventName={Amplitude.Event.ClickGetNotified}
                            extraProperties={{
                                integrationType: integrationType,
                            }}
                            onClick={saveGetNotifiedClicked}
                        >
                            Get notified
                        </TrackedButton>
                    </div>
                }
            </div>
        </Card>
    );
};

export default ComingSoonIntegrationComponent;
